type Props = {
  index?: string;
  eyebrow: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
};

/**
 * Mobile counterpart of the desktop EditorialHeading:
 * numbered kicker + hairline rule + Playfair display title.
 */
export function MobileEditorialHeading({ index, eyebrow, title, subtitle, align = "left" }: Props) {
  return (
    <div className={align === "center" ? "text-center" : "text-left"}>
      <div className={`flex items-center gap-2.5 ${align === "center" ? "justify-center" : ""}`}>
        {index && <span className="font-editorial text-[13px] italic text-accent">{index}</span>}
        <span className="h-px w-6 bg-white/25" aria-hidden />
        <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-white/55">{eyebrow}</p>
      </div>
      <h2 className="mt-3 font-editorial text-[26px] font-semibold leading-[1.12] tracking-[-0.01em] text-white text-balance">
        {title}
      </h2>
      {subtitle && <p className="mt-3 text-[14px] leading-relaxed text-white/65 text-balance">{subtitle}</p>}
    </div>
  );
}
